module.exports = __webpack_public_path__ + "img/wms.bf2b5fe3.png";